import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { ThirdPartyTracking } from '../../../../../errors/user-friendly-error-message-service/code-constants';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { useWalletRegistrationErrorContext } from '../../contexts/wallet-registration-error-context';
import { useWalletRegistrationFormContext } from '../../contexts/wallet-registration-form-context';
import { useBlackBox } from '../../hooks/use-black-box';

export const BlackBoxDeviceDetection = ({ markFormComplete }) => {
  const { walletForm, updateWalletForm } = useWalletRegistrationFormContext();
  const { setErrors } = useWalletRegistrationErrorContext();

  useEffect(() => {
    markFormComplete(FORM_REQUIREMENTS.IO_BLACK_BOX, !!walletForm[FORM_REQUIREMENTS.METADATA]?.[FORM_REQUIREMENTS.IO_BLACK_BOX]);
  }, [walletForm, markFormComplete]);

  const onSuccess = useCallback(
    (blackBoxValue) => {
      updateWalletForm([FORM_REQUIREMENTS.METADATA, FORM_REQUIREMENTS.IO_BLACK_BOX], blackBoxValue);
    },
    [updateWalletForm],
  );

  const onError = useCallback(() => {
    setErrors([
      {
        Code: ThirdPartyTracking,
        ErrorContext: {
          type: 'wallet',
        },
      },
    ]);
  }, [setErrors]);

  useBlackBox(onSuccess, onError);

  return null;
};

BlackBoxDeviceDetection.propTypes = {
  markFormComplete: PropTypes.func.isRequired,
};
